import { limit } from "firebase/firestore";
import { min } from "lodash";

const en = {
  //CHARGERS
  numberOfChargers: `Number of Chargers`,
  numberOfChargingSessions: `Number of Charging Sessions`,
  numberOfUsers: `Number of Users`,
  numberOfVehicles: `Number of Vehicles`,
  numberOfKWH: `Number of KW's`,
  chargingAmount: `Number of Charging Sessions`,
  chargeAmount: `Number of charges`,
  chargerStatus: `Charger Status`,
  chargerProvider: `Charger Provider`,
  usersLogged: `Users Logged`,
  username: `Username`,
  maxCharge: 'Max. Charger',
  useLoadBalance: 'Use LoadBalance',
  maxVoltage: 'Max. Voltage',
  maxAmps: 'Max. Amps',
  password: `Password`,
  passwordConfirm: `Confirm Password`,
  newPassword: `New Password`,
  confirmNewPassword: `Confirm New Password`,
  currentPassword: `Current Password`,
  remove: 'Remove',
  removeProfie: 'Remove Profile',
  removeProfileConfirm: 'Are you sure you want to remove this profile?',
  stackLevelIteger: 'Stack level must be an integer',
  stackLevelrequired: 'Stack level is required',
  chargingProfileKindRequired: 'Charging profile kind is required',
  chargingRateUnitRequired: 'Charging rate unit is required',
  durationMustBeIteger: 'Duration must be an integer',
  schedulePeriodRequired: 'At least one schedule period is required',
  SchedulePeriodrequired: 'Schedule period is required',
  startPeriodRequired: 'Start period is required',
  limitIsRequired: 'Limit is required',
  addSchedulePeriod: 'Add Period',
  addProfile: 'Add Profile',
  viewProviles: 'View Profiles',

  chargerGroupRequired: 'Charger group is required',
  userGroupRequired: 'User group is required',

  stackLevel: 'Stack Level',
  chargingProfilePurpose: 'Charging Profile Purpose',
  chargingProfileKind: 'Charging Profile Kind',
  recurrenceKind: 'Recurence Kind',
  chargingRateUnit: 'Charging Rate Unit',	
  minChargingRate: 'Min. Charging Rate',
  duration: 'Duration',
  startPeriod: 'Start Period',
  limit: 'Limit',
  numberPhases: 'Number of Phases',
  schedulePeriod: 'Schedule Period',
  validFrom: 'Valid From',
  validTo: 'Valid To',
  startSchedule: 'Start Schedule',

  chargingProfiles: 'Charging Profiles',
  addChargingProfile: 'Add Charging Profile',
  editChargingProfile: 'Edit Charging Profile',
  
  updateChargerLocation: 'Update Charger Location?',
  removeLocation: 'Remove Location',
  editLocation: 'Edit Location',
  location: 'Location',
  chargersWithoutProvisioning: `Unregistered chargers`,
  //BUTTONS AND FIELDS
  forgotPassword: `Forgot Password?`,
  rememberMe: `Relembrar-me`,
  signin: `Login to Seeligg Backoffice`,
  insertDetails: `Enter your details bellow`,
  login: `Login`,
  logout: `Exit`,
  welcome: 'Welcome to',
  seeliggExplain: 'Electric car charging management platform',
  email: `Email`,
  name: `Name`,
  paymentType: `Payment Type`,
  surname: `Surname`,
  firstname: `First Name`,
  lastname: `Last Name`,
  phoneNumber: `Phone number`,
  address: `Address`,
  image: `Image`,
  year: `Year`,
  yes: `Yes`,
  no: `No`, 
  defineTariffPrice: `Set the price for each tariff`,
  tariffPrice: `The price must be set in your local currency`,
  chargingUpTo: ` - charging up to`,
  moeda: `Coin`,
  minWalletValue: `Min. value Wallet`,
  faturation: `Faturation`,
  of: `of`,
  postalCode: `Postal Code`,
  city: `City`,
  country: `Country`,
  private: `Private?`,
  language: `Language`,
  description: `Description`,
  habilitarfaturacao: `Enable billing`,
  openMultiSeccion: `Enable multiple sessions`,
  openFreeCharge: `Enable free charging`,
  role: `Role`,
  roles: `Roles`,
  user: `User`,
  users: `Users`,
  userProfile: `User Profile`,
  vehicle: `Vehicle`,
  vehicles: `Vehicles`,
  close: `Close`,
  copyGroup: `Copy Group`,
  groupCopySucessful: `Group copied successfully.`,
  loadebalanceLimit: `Loadbalance limit`,
  charger: `Charger`,
  countryRequired: `Country is required`,
  chargers: `Chargers`,
  maxCharger: `Maximum Loading`,
  maxAmps: `Maximum Amps`,
  maxPower: `Maximum Power`,
  maxVoltage: `Maximum charge Voltage`,
  typeRequired: `Type is required`,
  success: `Success`,
  successful: `successfully.`,
  addedSucessful: `successfully added.`,
  updatedSucessful: `updated successfully.`,
  updatePassword: `Update Password`,
  updatePasword: `Update Password?`,
  deletedSucessful: `deleted successfully.`,
  error: `Error`,
  errorOccured: `An error occurred.`,
  errorOccuredTryAgain: `An error occurred. Please try again.`,
  errorOccuredTryAgainLater: `An error occurred. Please try again later.`,
  vehiclesManagement: `Vehicle Management`,
  usersManagement: `User Management`,
  chargersManagement: `Charger Management`,
  chargersAdminMode: `Put chargers in admin mode`,
  providers: `Providers`,
  providersGroups: `Providers Groups`,
  provider: `Provider`,
  private: `Private?`,
  addUser: `Add User`,
  timeAvaileble: `The charger availability start time must be less than the charger availability end time!`,
  addProvider: `Add Provider`,
  addVehicle: `Add Vehicle`,
  addCharger: `Add Charger`,
  addBrand: `Add Brand`,
  addModel: `Add Model`,
  id: `ID`,
  addOutletType: `Add Outlet`,
  providersList: `Provider List`,
  chargerLogs: `Charger Logs`,
  chargerList: `Chargers List`,
  chargersWithoutLocation: `Chargers without location`,
  chargersInformation: `Chargers Information`,
  vehicleList: `Vehicle List`,
  usersList: `Users List`,
  brandsList: `Brands List`,
  firmwareList: `Firmwares List`,
  modelsList: `Model List`,
  outletTypesList: `Outlet List`,
  settings: `Settings`,
  log: `Log`,
  logs: `Logs`,
  new: `New`,
  back: `Back`,
  add: `Add`,
  edit: `Edit`,
  generateQRCodes: `Generate QR-Codes`,
  searchHere: `Search here...`,
  save: `Save`,
  saveChanges: `Save Changes`,
  search: `Search`,
  usersAssociateTo: `Users associated with -`,
  searchEmailUsername: `Search by Email or Username`,
  brand: `Brand`,
  editTariff: `Edit Tariff`,
  createTariff: `Create Tariff`,
  brands: `Brands`,
  model: `Model`,
  models: `Models`,
  addConnector: `Add Connector`,
  connector: `Connector`,
  balance: `Balance`,
  company: `Company`,

  chargingProfile: `Charging Profile`,
  chargingProfileRequired: `Charging Profile is required`,
  firmwareRequired: `Firmware is required`,
  retrieveDateRequired: `Retrieve Date is required`,

  

  rejectSelectedConfirm: 'Are sure that you want to reject selected items?',
  reject: 'Reject',
  rejectSelected: 'Reject Selected picture',
   
  deleteItemConfirmation: 'Are sure that you want to delete this item?',
  
  deleteBrand: 'Are sure that you want to delete brand ',
  deleteVehicle: 'Are sure that you want to delete vehicle ',
  deleteOutlet: 'Are sure that you want to delete vehicle outlet ',
  deleteModel: 'Are sure that you want to delete model ',

  outletType: `Outlet`,
  outletTypes: `Outlets`,
  outletTypesAssociated: `Outlets associated to this model`,
  editUser: `Edit User`,
  editUserProfile: `Edit User Profile`,
  editUserProfilePassword: `Edit User Password`,
  editProvider: `Edit Provider`,
  editVehicle: `Edit Vehicle`,
  editCharger: `Edit Charger`,
  editChargerInformation: `Edit Charger Information`,
  chargersInformation: `Charger Information`,
  userInfo: `User Information`,
  creditsManagement: `Credits Management`,
  amperes: 'Amps',
  deleteCurrentCharger: `Are sure that you want to delete the current charger?`,
  editBrand: `Edit Brand`,
  editModel: `Edit Model`,
  editOutletType: `Edit Outlet`,
  editChargerLocation: `Edit Charger Location`,
  deleteConfirmationA: `Are you sure you want to delete this`,
  deleteConfirmationB: `Are you sure you want to delete this`,
  deleteTariff: `Are you sure you want to delete tariff `,
  deleteGroup: `Are you sure you want to delete group `,
  deleteFirmeware: `Are you sure you want to delete firmware `,
  removeFromGroup: `Remove from group`,
  addToGroup: `Add to group`,
  tariffList: `Tariffs List`,
  tariffsManagement: `Tariffs Management`,
  tariff: `Tariff`,
  active: `Active`,
  inactive: `Inactive`,
  credits: `Credits`,
  transactionsManagemant: `Transactions Management`,
  walletstransactions: `Wallets Transactions`,
  newTransaction: 'New Transaction',
  transactions: `Transactions`,
  createUser: `Create new user`,
  createVehicle: `Create new vehicle`,
  createCharger: `Create new charger`,
  createBrand: `Create new brand`,
  createModel: `Create new model`,
  createOutletType: `Create new outlet`,
  createButton: `Create`,
  map: `Map`,
  list: `List`,
  amount: `Amount`,
  serialNumber: `Serial Number`,
  dataType: `Data Type`,
  dataNotFound: `Data not found`,
  dateCreated: `Created date`,
  dateChange: `Date Changed`,
  endDate: `End date`,
  entryDate: `Entry Date`,
  entryText: `Log Description`,
  origin: `Origin`,
  type: `Type`,
  observation: `Observation`,
  operation: `Operation`,
  addCredit: `Add Credit`,
  creditsAmount: `Amount of Credits`,
  addCreditsToUser: `Add credit to a user`,
  addCreditToUser: `Add credit to this user`,
  notifications: `Notifications`,
  profile: `Profile`,
  tooltipTitle: `Please select the chargers in the table that you want to manage, then press this button`,
  chooseFile: `Choose File`,
  noFile: `No file selected`,
  file: `File`,
  selected: `selected`,
  version: `Version`,
  chargingSessions: `Charging Sessions`,
  createChargingSession: `Create Charging Session`,
  actionToPerfom: `What charging action you want to perfom:`,
  terminate: `Terminate Session`,
  create: `Create Session`,
  agent: `Agent`,
  agents: `Agents`,
  agentsList: `Agents List`,
  addAgent: `Add Agent`,
  editAgent: `Edit Agent`,
  newAgent: `New Agent`,
  updateFirmware: `Update Firmware`,
  uploadFirmware: `Upload Firmware`,
  firmwareVersion: `Firmware Version`,
  firmware: `Firmware`,
  firmwares: `Firmwares`,
  fileName: `File Name`,
  next: `Next`,

  update: `Update `,
  upload: `Upload `,

  execute: `Execute`,
  nome: `Name`,
  addressLine1: `Address Line 1`,
  addressLine2: `Address Line 2`,
  addressPostalCode: `Postal Code`,
  groups: `Groups`,
  group: `Group`,
  billingFrequencyRequired: `Billing Frequency is required`,
  billingFrequency: `Billing Frequency`,
  address1: `Address 1`,
  address2: `Address 2`,
  deleteAgent: `Delete agent`,
  addCreditToGroup: `Add Credit to Group:`,
  userRole: `User Role`,
  paymentsManagement: `Payments Management`,
  payments: `Payments`,
  paymentsList: `Payments List`,
  paymentStatus: `Payment Status`,
  userGroups: `Users Groups`,
  currency: `Currency`,
  status: `Status`,
  states: `States`,
  paymentType: `Payment Type`,
  invoices: `Invoices`,
  invoicesList: `Invoices List`,
  invoiceFile: `Invoice File`,
  paymentLogs: `Payment Logs`,
  paymentLogsList: `Payment Logs List`,
  networks: `Networks`,
  updateNetwork: `Update Network`,
  chooseCharger: `Choose Charger`,
  sorryPageNotFound: 'Sorry, page not found!',
  pageNotFoundTitle: 'Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be sure to check your spelling.',
  goHome: `Go Home`,
  title404: '404 Page Not Found',
  title500: '500 Internal Server Error',
  manageBillingMethod: `Manage Billing Method`,
  tryLatter: 'There was an error, please try again later.',
  manageTaxFree: `Manage Tax Free`,
  billing: `Billing`,
  billingMethod: `Billing Method`,
  price: `Price`,
  changeTariffPrice: `Change Tariff Price`,
  taxFree: `Tax Free`,
  cancel: `Cancel`,
  delete: `Delete`,
  details: `Details`,
  publicAddress: `Public Address`,
  privateAddress: `Private Address`,
  macAddress: `MAC Address`,
  port: `Port`,
  gateway: `Gateway`,
  subnetMask: `Subnet Mask`,
  dns: `DNS`,
  wifiSSid: `Wifi SSID`,
  wifiPassword: `Wifi Password`,
  privateIP: `Private IP`,
  publicIP: `Public IP`,
  removeConnectorConfirmation: `Are you sure you want to remove this connector?`,

  public1: `Public`,
  private1: `Private`,

  // ------------------REQUIRED DATA--------------------------- 
  firstnameRequired: `Firstname is required`,
  providerRequired: `Provider is required`,
  lastnameRequired: `Lastname is required`,
  passwordConfirmRequired: `Password confirmation is required`,
  passwordMatch: `Passwords must match`,
  minimunLength: `Minimum of 8 characters`,
  validEmail: `Please insert a valid email`,

  connectorRequired: `Connector is required`,
  hardwareRequired: `Hardware ID is required`,
  userNameRiquired: `User Name is required`,
  phoneRequired: `Phone is required`,
  serialNumberRequired: `Serial Number is required`,
  emailRequired: `Email is required`,
  passwordRequired: `Password is required`,
  nameRequired: `Name is required`,
  powerRequired: `Power is required`,
  addressLine: `Address`,
  currencyRequired: `Currency is required`,
  taxeRequired: `Tax regime is required`,
  counrtyRequired: `Country is required`,
  websiteRequied: `Website is required`,
  emailValide: `Email must be a valid email address`,
  addressRequired: `Address is required`,
  postalCodeRequired: `Postal Code is required`,
  paymentMethodRequired: `Payment Method is required`,
  chargerRequired: `Charger is required`,
  vehicleRequired: `Vehicle is required`,
  optionRequired: `Option is required`,

  noResultsFor: `No results found for `,
  checkingKeywords: `. Try checking for typos or using complete words.`,
  pleaseEnterKeywords: `Please enter keywords`,
  verifyEmail: `Verify Email`,
  verifyEmailTitle: `Verify your Email Address to activate your account.`,
  resultsNotFound: `Results not found`,
  chargerPictures: `Charger Pictures`,

  // CHARGER STATES
  notConnected: `Not Connected`,
  chargerGrop: `Charger Group`,
  chargerGropuAssociate: `Chargers Groups Associate with -`,
  connected: `Connected`,
  evCharging: `Vehicle Charging`,
  evConnected: `Vehicle Connected`,
  evNotConnected: `Vehicle Not Connected`,
  operationSusscessfuly: `Operação realizada com sucesso`,
  standby: `Standby`,
  freeCharge: `Free Charge`,
  sendCommand: `Send Command`,
  command: `Command`,
  send: `Send`,
  currentPerPhase: `Current Per Phase`,
  currentPerPhaseRequired: `Current Per Phase is required`,
  provisioningDate: `Provisioning Date`,
  rate: `Rate`,
  pictureUnapproved: `Unapprove, select to approve`,

  ocppChargers: 'OCPP Chargers',	
  creditsManagement: 'Credits Management',
  chargerGroups: 'Charger Groups',
  chargerGroup: 'Groups',
  addGroup: 'Add group',
  manufacturer: 'Manufacturer', 
  firmware_version: 'Firmware Version',
  editGroup: 'Edit group',
  providerGroups: 'Provider Groups',
  providerGroup: 'Group',
  editChargerInformation: 'Edit Charger Information',
  coefficient: 'Coefficient',
  changeProvider: 'Change Provider',
  changeWifiNetwork: 'Change Wifi Network',

  information: 'Information',
  network: 'Network',

  providerInformation: 'Provider Information',
  chargeState: 'Charge State',

  addProviderMessage: `This charger has no provider assigned, you need to assign a provider first to be able to edit the location`,

  userChargeHistory: 'User Charge History',

  addProviderFirst: 'Please add a provider first and then add a payment method',

  timeStart: 'Start Time',
  timeEnd: 'End Time',
  totalEnergy: 'Total Energy',
  totalCost: 'Total Cost',
  print: 'Print',

  tariffs: 'Tariffs',
  tariff: 'Tariff',
  transactions: 'Transactions',
  chargementList: 'Chargement List',
  evNotCharging: 'Vehicle Not Charging',
  roads: 'Roads',
  satellite: 'Satellite',
  duration: 'Duration',

  stateDescription: {
    notConnected: 'Charger is OFFLINE',
    evCharging: 'Charger is ONLINE and EV is CHARGING',
    evConnected: 'Charger is ONLINE, with an EV connected but is NOT CHARGING',
    evNotConnected: 'Charger is ONLINE, but EV is not connected',
    standby: 'Charger is started fot the first time and is waiting for a command',
    noHeart: 'No Ground',
  },

  state: 'State',

  chargements: 'Chargements',
  energy: 'Energy',

  addTax: 'Add Tax',
  editTax: 'Edit Tax',
  tax: 'Tax',
  taxes: 'Taxes',
  taxesList: 'Taxes List',
  value: 'Value',
  minWalletValue: 'Minimum Wallet Value',
  availability: `Availability`,
  confKey: `Configuration key`,

  deleteChargingProfiles: `Are you sure that you want to delete this charging profile?`,
  deleteChargingProfile: `Delete Charging Profile`,
  start_schedule: 'Start Schedule',

  available: {
    from: 'Available from',
    until: 'Available until',
  },

  valid: {
    from: 'Valid from',
    until: 'Valid until',
  },



  acess: 'acess',
  glossary: 'Glossary',
  filters: 'Filters',

  hourly: 'Hourly',
  daily: 'Daily',
  weekly: 'Weekly',
  biweekly: 'Biweekly',
  monthly: 'Monthly',
  yearly: 'Yearly',
  glossary: 'Glossary',
  filter: 'Filter',
  multipleSessions: 'Multiple Sessions',
  approveSelected: 'Approve selected pictures',
  picturesSelected: ' selected image(s)',
  noPicturesSelected: 'No image selected',
  disassociate: 'Disassociate',
  approve: 'Approve',
  approveSelectedConfirm: 'Are you sure that you want to approve selected images?',
  pictures: 'Pictures',


  imageRequired: 'Image is required',

  removeRFI: "Remove RFID",
  deleteRFIDMEssage: 'Are sure that you want to delete the RFID ',
  removeRFIDConfirmation: 'Are sure that you want to remove RFID ',
  fromUser: ' of user ',
  rfiList: 'RFID List',
  deleteSelectedItems: 'Are sure that you want to delete all selected items?',
  providerAccount: 'Account origin',

  associateUser: 'Associate RFID(s) to Client',
  removeRFIDToUser: "Remove RFID(s) From Client",
  removeRFIDConfirm: 'Remove RFID(s) from all selected Clients?',
  chargementList: 'Chargement List',
  confirmation: 'Confirmation',
  enable: 'Enable',
  disable: 'Disable',
  fromGroup: 'of this group?',
  disableMessage: 'Disable all this selected chargers?',  
  message: `Message`,
  enabledMessage: 'Enable all this selected chargers?',
  deleteConfirmMessage: 'Are sure that you want to delete all this selected chargers?',
  deleteVehicleMessage: 'Are sure that you want to delete all this selected vehicles?', 
  deleteAllGroupsMessage: 'Are sure that you want to delete all this selected groups?',
  deleteSelectedUsers: 'Are sure that you want to delete all this selected users?',
  deleteCharger: 'Are sure that you want to delete charger ',

  deleteBrand: 'Are sure that you want to delete brand ',
  deleteVehicle: 'Are sure that you want to delete vehicle ',
  deleteOutlet: 'Are sure that you want to delete vehicle outlet ',
  deleteModel: 'Are sure that you want to delete model ',

  deleteProvider: 'Are sure that you want to delete provider',
  deleteProviders: 'Are sure that you want to delete all these providers?',
  deleteUser: 'Are sure that you want to delete user',
  website: 'Website',
  ocppChargers: 'Ocpp Chargers',
  ocppChargersList: 'Ocpp Chargers List',
  exportToExcel: 'Export to Excel',
  chargingReport: `Charging Report`,
  chargingReports: `Charging Reports`,
  chargeReportsList: `Charging Reports List`,
  user_charger: 'User / Charger',
  addChargerGroup: 'Add Charger Group',
  editChargerGroup: 'Edit Charger Group',
  availabilityWarning: ` The charger availability start time must be less than the charger availability end time!`,
  billingType: `Billing Type`,

  commission: 'Commission',

  priceRequired: `Price is required`,
  priceMinValue: `Minimum value is 0`,
  paymentTypeRequired: `Payment Type is required`,
  minValue: `Minimum value `,
  mangePaymentTypeChargers: `Here you can manage the payment type for the selected chargers.`,


  search: {
    email: 'Search by email',
    username: 'Search by username',
    emailOrUsername: 'Search by email or username',
    button: 'Search',
  },

  commands: {
    start: `Start charging`,
    stop: `Stop charging`,
    startDebugMode: `Start debug mode`,
    stopDebugMode: `Stop debug mode`,
    foreChargeStop: `Force charging end`,
  }
};

export default en;
